import React from 'react'
import { connect } from 'dva'
import { modelUtils,seatsOut } from '@/utils'
import { framework_tool, component_tool, utils_tool } from '@/tool'
import { QsPreview } from '@/components'
let { WizContainer } = framework_tool
let { WizSpin } = component_tool
let { Session } = utils_tool

const getParamRecord = (history) => {
    let record = {}
    if (history.location && (history.location.pathname === '/biz/survey/surveyRecordInfo/surveyRecordInfoDetail'
        || history.location.pathname === '/workflow/apply/applyInfo/surveyRecordInfoDetail'
        || history.location.pathname === '/face/classList/classAideDetail/classStudentSurveyList/surveyRecordInfoDetail'
    )) {
        if (history.location && history.location.record) {
            record = history.location.record
            Session.set('surveyRecordInfoDetail', record)
        } else {
            record = Session.get('surveyRecordInfoDetail') || {}
        }
    }
    return record
}

class surveyRecordInfoDetail extends WizContainer {

    componentName = 'surveyRecordInfoDetail'

    constructor(props) {
        super(props)
        let { history } = props
        this.record = getParamRecord(history)
    }
    componentDidMount() {
      seatsOut({ fun: this._seatsLoginOut })
    }

    propsAndStateOnChange = {
      seatsLoginOut: this._seatsLoginOutOver.bind(this),
    }

    _seatsLoginOutOver(nextProps, nextState) {
      if (nextProps.seatsLoginOut.success && nextProps.seatsLoginOut.data) {
      } else {
        wizNotice.error(nextProps.seatsLoginOut.msg);
      }
      return true;
    }
    _seatsLoginOut = (params) => {
      ClinkAgent.setup({ sipPhone: false, debug: false }, function () {
        // 注册退出响应回调方法
        ClinkAgent.registerCallback(ClinkAgent.ResponseType.LOGOUT, function (result) {
          if (result.code === 0) {
            // 退出成功
            console.log('退出成功777')
          } else {
            // 退出失败
          }
        });
      });
      ClinkAgent.logout({ logoutMode: 1, removeBinding: 0 });
      this.doAction({
        path: 'smartPhone/seatsLoginOut',
        payload: {
          key: "seatsLoginOut",
          apiParams: {
            ...params
          }
        }
      });
    }
    _render() {
        return (
            <QsPreview data={{ ...this.record, preview: false, yunCall:true }} />
        )
    }
}

const mapStateToProps = (state, ownProps) => {
  const { smartPhone } = state;
  const seatsLoginOut = modelUtils.getModelEntity(smartPhone, 'seatsLoginOut');

  return {
    seatsLoginOut
  }
};

export default connect(mapStateToProps)(surveyRecordInfoDetail);
